import Handlebars from "handlebars";

Handlebars.registerHelper("strip_first_char", function (str, options) {
  return str.slice(1);
});
